function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevelopmentCuate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M685.44,125.36l5.89-9.49-2.91-1.8a2.66,2.66,0,0,1-1.23-2.5,13.25,13.25,0,0,0,0-1.67,2.67,2.67,0,0,1,1.39-2.41l3-1.61L686.36,96l-3,1.62a2.66,2.66,0,0,1-2.77-.18,15.13,15.13,0,0,0-1.42-.88,2.64,2.64,0,0,1-1.4-2.41l.1-3.42-11.16-.35-.1,3.43A2.66,2.66,0,0,1,665,96.15l-.73.37c-.25.13-.48.27-.72.41a2.63,2.63,0,0,1-2.77,0l-2.93-1.81L652,104.63l2.91,1.81a2.67,2.67,0,0,1,1.23,2.5,15.26,15.26,0,0,0-.06,1.66,2.67,2.67,0,0,1-1.38,2.41l-3,1.61,5.28,9.85,3-1.62a2.66,2.66,0,0,1,2.77.18,14.87,14.87,0,0,0,1.41.87,2.67,2.67,0,0,1,1.41,2.41l-.11,3.43,11.16.34.11-3.42a2.66,2.66,0,0,1,1.55-2.31c.25-.11.5-.24.74-.37s.48-.26.72-.41a2.65,2.65,0,0,1,2.78,0Zm-9.45-7a9.15,9.15,0,1,1,3.75-12.38A9.14,9.14,0,0,1,676,118.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.88,358.9,124,352.12l-2.07,1.2a1.85,1.85,0,0,1-2-.07,10.29,10.29,0,0,0-1-.58,1.86,1.86,0,0,1-1-1.66v-2.39h-7.83V351a1.86,1.86,0,0,1-1,1.66,9.12,9.12,0,0,0-1,.58,1.85,1.85,0,0,1-2,.07l-2.08-1.2-3.91,6.78,2.09,1.2a1.87,1.87,0,0,1,.91,1.72c0,.19,0,.39,0,.58s0,.38,0,.57a1.87,1.87,0,0,1-.91,1.72l-2.09,1.21,3.91,6.78,2.08-1.2a1.85,1.85,0,0,1,2,.07c.33.21.66.4,1,.58a1.85,1.85,0,0,1,1,1.65v2.4h7.83v-2.4a1.86,1.86,0,0,1,1-1.65,11,11,0,0,0,1-.58,1.85,1.85,0,0,1,2-.07l2.08,1.2,3.91-6.78-2.08-1.2a1.87,1.87,0,0,1-.91-1.72c0-.19,0-.39,0-.58s0-.39,0-.58a1.87,1.87,0,0,1,.91-1.72Zm-7.48,3.5A6.41,6.41,0,1,1,114,356,6.4,6.4,0,0,1,120.4,362.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.08,259.2a30.47,30.47,0,1,0,30.47,30.47A30.45,30.45,0,0,0,96.08,259.2Zm0,44.69a14.23,14.23,0,1,1,14.23-14.22A14.23,14.23,0,0,1,96.08,303.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.94 260.46 90.22 260.46 90.87 252.16 101.29 252.16 101.94 260.46",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.63 264.41 71.35 272.69 65.94 266.37 73.31 259 79.63 264.41",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.65 282.97 66.65 294.69 58.36 294.04 58.36 283.62 66.65 282.97",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.6 305.27 78.89 313.56 72.56 318.97 65.19 311.6 70.6 305.27",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.16 318.25 100.88 318.25 100.23 326.55 89.81 326.55 89.16 318.25",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.47 314.3 119.75 306.02 125.16 312.34 117.79 319.71 111.47 314.3",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.45 295.74 124.45 284.02 132.74 284.67 132.74 295.09 124.45 295.74",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.5 273.44 112.21 265.15 118.54 259.75 125.91 267.12 120.5 273.44",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.1,154.82a30.48,30.48,0,1,0,30.47,30.48A30.47,30.47,0,0,0,637.1,154.82Zm0,44.7a14.23,14.23,0,1,1,14.23-14.22A14.22,14.22,0,0,1,637.1,199.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "642.96 156.09 631.24 156.09 631.89 147.79 642.31 147.79 642.96 156.09",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "620.65 160.04 612.37 168.32 606.96 162 614.33 154.63 620.65 160.04",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "607.67 178.6 607.67 190.32 599.38 189.67 599.38 179.25 607.67 178.6",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.62 200.9 619.91 209.19 613.59 214.6 606.22 207.23 611.62 200.9",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "630.19 213.88 641.9 213.88 641.26 222.18 630.83 222.18 630.19 213.88",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "652.49 209.93 660.78 201.65 666.18 207.97 658.81 215.34 652.49 209.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "665.47 191.37 665.47 179.65 673.76 180.3 673.76 190.72 665.47 191.37",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "661.52 169.07 653.24 160.78 659.56 155.37 666.93 162.74 661.52 169.07",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-31"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "56.76 395.82 136.32 395.57 215.88 395.49 375 395.32 534.12 395.49 613.68 395.57 693.24 395.82 613.68 396.06 534.12 396.15 375 396.32 215.88 396.15 136.32 396.06 56.76 395.82",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-31"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.28,
    y: 96.15,
    width: 441.45,
    height: 295.29,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.49,
    y: 99.75,
    width: 435.03,
    height: 288.09,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.78,
    y: 413.59,
    width: 556.44,
    height: 20.27,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.78 413.59 154.28 391.44 595.72 391.44 653.22 413.59 96.78 413.59",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.41 405.73 196.51 391.44 553.49 391.44 590.59 405.73 159.41 405.73",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.74,
    y: 121.53,
    width: 386.51,
    height: 244.52,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.74,
    y: 121.53,
    width: 386.51,
    height: 9.41,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.22,126.24a2.33,2.33,0,1,1-2.33-2.33A2.33,2.33,0,0,1,189.22,126.24Z",
    style: {
      fill: "#2C3891"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.75,126.24a2.34,2.34,0,1,1-2.33-2.33A2.33,2.33,0,0,1,198.75,126.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.28,126.24a2.34,2.34,0,1,1-2.33-2.33A2.33,2.33,0,0,1,208.28,126.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.57,
    y: 236.19,
    width: 70.42,
    height: 54.03,
    transform: "translate(803.56 526.41) rotate(180)",
    style: {
      fill: "#2C3891"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.58,248a6.39,6.39,0,1,0,5-5A6.4,6.4,0,0,0,373.58,248Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.8 278.58 436.99 278.58 413.4 249.5 389.8 278.58",
    style: {
      fill: "#2C3891"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.8 278.58 436.99 278.58 413.4 249.5 389.8 278.58",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.57 278.61 408.42 278.61 387.49 259.67 366.57 278.61",
    style: {
      fill: "#2C3891"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.57 278.61 408.42 278.61 387.49 259.67 366.57 278.61",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.57,
    y: 278.58,
    width: 70.42,
    height: 11.64,
    style: {
      fill: "#2C3891"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.57,
    y: 278.58,
    width: 70.42,
    height: 11.64,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.83,
    y: 236.19,
    width: 52.9,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.83,
    y: 246.51,
    width: 153.08,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.83,
    y: 256.31,
    width: 153.08,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.83,
    y: 266.1,
    width: 153.08,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.83,
    y: 275.89,
    width: 153.08,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.83,
    y: 285.68,
    width: 153.08,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.32,
    y: 148.82,
    width: 52.9,
    height: 11.91,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.32,
    y: 168.94,
    width: 108.68,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.32,
    y: 178.73,
    width: 108.68,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.32,
    y: 188.52,
    width: 108.68,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.32,
    y: 198.31,
    width: 108.68,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.32,
    y: 211.34,
    width: 108.68,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.32,
    y: 221.13,
    width: 108.68,
    height: 4.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.42,
    y: 148.82,
    width: 96.73,
    height: 12.12,
    style: {
      fill: "#2C3891"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.69,
    y: 160.94,
    width: 96.22,
    height: 129.06,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.17,290.22H452.42V160.73h96.75ZM453,289.79h95.68V161.16H453Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.94 290.09 452.44 289.93 548.65 160.86 549.15 161.02 452.94 290.09",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "548.65 290.09 452.44 161.02 452.94 160.86 549.15 289.93 548.65 290.09",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.03,
    y: 149.03,
    width: 115.28,
    height: 76.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.85,225.58v-.19l0-76.53H201l115.48,0,0,76.73h-.19Zm.37-76.34,0,75.95,114.9,0,0-75.95Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.22,149.24c9.69,6.15,19.33,12.39,28.95,18.64L259,186.76l28.66,19.08,14.28,9.61,14.23,9.71-14.51-9.27-14.45-9.36-28.8-18.88-28.66-19.08C220.19,162.17,210.67,155.76,201.22,149.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.14,149.24c-9.46,6.52-19,12.93-28.51,19.33L259,187.65l-28.8,18.88-14.44,9.36-14.51,9.27,14.22-9.71,14.28-9.61,28.66-19.08,28.8-18.88C296.8,161.63,306.44,155.39,316.14,149.24Z",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Crane--inject-31"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.41,
    y: 200.32,
    width: 22.36,
    height: 2.18,
    transform: "translate(-103.97 161.88) rotate(-46.68)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 209.14,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 192.18,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 190.23,
    width: 2.18,
    height: 22.36,
    transform: "translate(-101.23 147.85) rotate(-43.31)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.41,
    y: 217.27,
    width: 22.36,
    height: 2.18,
    transform: "translate(-116.3 167.19) rotate(-46.68)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 226.09,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 209.14,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 207.18,
    width: 2.18,
    height: 22.36,
    transform: "translate(-112.85 152.46) rotate(-43.31)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.41,
    y: 234.23,
    width: 22.36,
    height: 2.18,
    transform: "translate(-128.64 172.52) rotate(-46.68)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 243.05,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 226.09,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 224.14,
    width: 2.18,
    height: 22.36,
    transform: "translate(-124.48 157.08) rotate(-43.31)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.41,
    y: 251.18,
    width: 22.36,
    height: 2.18,
    transform: "translate(-140.97 177.84) rotate(-46.68)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 260,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 243.05,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 241.09,
    width: 2.18,
    height: 22.36,
    transform: "translate(-136.11 161.69) rotate(-43.31)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.41,
    y: 268.14,
    width: 22.36,
    height: 2.18,
    transform: "translate(-153.31 183.17) rotate(-46.68)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 276.95,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 260,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 258.04,
    width: 2.18,
    height: 22.36,
    transform: "translate(-147.74 166.31) rotate(-43.31)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.41,
    y: 285.09,
    width: 22.36,
    height: 2.18,
    transform: "matrix(0.69, -0.73, 0.73, 0.69, -165.64, 188.49)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 293.91,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 276.95,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 275,
    width: 2.18,
    height: 22.36,
    transform: "translate(-159.37 170.93) rotate(-43.31)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.41,
    y: 302.04,
    width: 22.36,
    height: 2.18,
    transform: "matrix(0.69, -0.73, 0.73, 0.69, -177.98, 193.81)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 310.86,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 293.91,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 291.95,
    width: 2.18,
    height: 22.36,
    transform: "translate(-171 175.54) rotate(-43.31)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.41,
    y: 319,
    width: 22.36,
    height: 2.18,
    transform: "translate(-190.31 199.13) rotate(-46.68)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 327.81,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 310.86,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 308.91,
    width: 2.18,
    height: 22.36,
    transform: "translate(-182.63 180.16) rotate(-43.31)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.41,
    y: 335.95,
    width: 22.36,
    height: 2.18,
    transform: "translate(-202.64 204.44) rotate(-46.68)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 344.77,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 327.81,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 325.86,
    width: 2.18,
    height: 22.36,
    transform: "translate(-194.25 184.78) rotate(-43.31)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.41,
    y: 352.91,
    width: 22.36,
    height: 2.18,
    transform: "translate(-215.03 209.9) rotate(-46.7)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 361.72,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 344.77,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 342.81,
    width: 2.18,
    height: 22.36,
    transform: "translate(-205.89 189.4) rotate(-43.31)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.41,
    y: 369.86,
    width: 22.36,
    height: 2.18,
    transform: "translate(-227.37 215.23) rotate(-46.7)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 378.68,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.92,
    y: 361.72,
    width: 15.71,
    height: 2.18,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.5,
    y: 359.77,
    width: 2.18,
    height: 22.36,
    transform: "translate(-217.51 194.01) rotate(-43.31)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.51,
    y: 372.05,
    width: 9.87,
    height: 22.66,
    transform: "translate(518.83 247.94) rotate(90)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.96,
    y: 283.23,
    width: 186,
    height: 5.68,
    transform: "translate(413.02 159.12) rotate(90)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.94,
    y: 283.23,
    width: 186,
    height: 5.68,
    transform: "translate(430.01 142.13) rotate(90)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.07 191.74 279.09 175.01 135.8 148.31 92.25 175.14 91.11 173.28 135.37 146.01 280.15 172.99 297.6 190.19 296.07 191.74",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.08 177.36 135.63 153.1 118.92 177.32 115.33 174.85 135.55 145.54 156.62 174.81 153.08 177.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.41,
    y: 174.22,
    width: 2.18,
    height: 22.36,
    transform: "translate(-49.95 255.07) rotate(-46.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.22,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.27,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.31,
    y: 184.31,
    width: 22.36,
    height: 2.18,
    transform: "translate(-53.5 236.08) rotate(-43.32)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.45,
    y: 174.22,
    width: 2.18,
    height: 22.36,
    transform: "translate(-55.28 242.73) rotate(-46.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.27,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.32,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.36,
    y: 184.31,
    width: 22.36,
    height: 2.18,
    transform: "translate(-58.12 224.45) rotate(-43.32)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.5,
    y: 174.22,
    width: 2.18,
    height: 22.36,
    transform: "translate(-60.6 230.4) rotate(-46.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.32,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.36,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.41,
    y: 184.31,
    width: 22.36,
    height: 2.18,
    transform: "translate(-62.74 212.82) rotate(-43.32)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.55,
    y: 174.22,
    width: 2.18,
    height: 22.36,
    transform: "translate(-65.93 218.06) rotate(-46.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.36,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.41,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.45,
    y: 184.31,
    width: 22.36,
    height: 2.18,
    transform: "translate(-67.36 201.19) rotate(-43.32)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.59,
    y: 174.22,
    width: 2.18,
    height: 22.36,
    transform: "translate(-71.25 205.72) rotate(-46.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.41,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.45,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.5,
    y: 184.31,
    width: 22.36,
    height: 2.18,
    transform: "translate(-71.98 189.56) rotate(-43.32)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.64,
    y: 174.22,
    width: 2.18,
    height: 22.36,
    transform: "translate(-76.58 193.39) rotate(-46.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.45,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.5,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.55,
    y: 184.31,
    width: 22.36,
    height: 2.18,
    transform: "translate(-76.59 177.92) rotate(-43.32)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.68,
    y: 174.22,
    width: 2.18,
    height: 22.36,
    transform: "translate(-81.91 181.05) rotate(-46.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.5,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.55,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.59,
    y: 184.31,
    width: 22.36,
    height: 2.18,
    transform: "translate(-81.21 166.3) rotate(-43.32)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.73,
    y: 174.22,
    width: 2.18,
    height: 22.36,
    transform: "translate(-87.23 168.71) rotate(-46.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.55,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.59,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.64,
    y: 184.31,
    width: 22.36,
    height: 2.18,
    transform: "translate(-85.83 154.66) rotate(-43.32)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.78,
    y: 174.22,
    width: 2.18,
    height: 22.36,
    transform: "translate(-92.56 156.37) rotate(-46.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.59,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.64,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.68,
    y: 184.31,
    width: 22.36,
    height: 2.18,
    transform: "translate(-90.45 143.03) rotate(-43.32)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.82,
    y: 174.22,
    width: 2.18,
    height: 22.36,
    transform: "translate(-97.88 144.04) rotate(-46.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.64,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.69,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.73,
    y: 184.31,
    width: 22.36,
    height: 2.18,
    transform: "translate(-95.07 131.4) rotate(-43.32)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.87,
    y: 174.22,
    width: 2.18,
    height: 22.36,
    transform: "translate(-103.21 131.7) rotate(-46.69)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.69,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.73,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.78,
    y: 184.31,
    width: 22.36,
    height: 2.18,
    transform: "translate(-99.69 119.78) rotate(-43.32)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.23,
    y: 173.25,
    width: 9.86,
    height: 22.66,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.09,
    y: 173.25,
    width: 9.87,
    height: 22.66,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.07,
    y: 195.91,
    width: 18.93,
    height: 11.3,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.09,
    y: 190.23,
    width: 206.51,
    height: 5.68,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.82 178.93 91.09 178.93 91.09 173.25 280.27 173.25 285.82 178.93",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.94,
    y: 177.36,
    width: 2.18,
    height: 15.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.44,295.67c1.31-1.82,2.71-3.58,4.11-5.32s2.85-3.45,4.31-5.14l.39-.46.37.47c2.16,2.69,4.31,5.38,6.4,8.12l3.14,4.12c1,1.4,2,2.77,3,4.18-1.17-1.27-2.29-2.58-3.43-3.87l-3.36-3.94c-2.23-2.63-4.4-5.3-6.56-8l.76,0c-1.48,1.68-2.95,3.36-4.49,5S252.06,294.11,250.44,295.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.71,
    y: 198.23,
    width: 2.18,
    height: 68.08,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.15,
    y: 198.95,
    width: 2.18,
    height: 68.08,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.8,
    y: 195.91,
    width: 28.73,
    height: 4.63,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.26,271.72l-.24,4.83-.7-.83a7.55,7.55,0,0,1,2.19.94,5.2,5.2,0,0,1,1.73,1.7,4.3,4.3,0,0,1-.12,4.59,4.49,4.49,0,0,1-3.88,2,4.72,4.72,0,0,1-3.61-2.16,4.49,4.49,0,0,0,3.6,1.73,3.88,3.88,0,0,0,3.17-2,3.26,3.26,0,0,0-.22-3.46,5.1,5.1,0,0,0-3.16-1.68l-.66-.1,0-.73-.24-4.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.53 261.8 273.53 269.69 259.17 273.1 244.81 269.69 244.81 261.8 273.53 261.8",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.39,266.43a1.67,1.67,0,1,1-1.66-1.67A1.66,1.66,0,0,1,251.39,266.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.28,266.43a1.67,1.67,0,1,1-1.67-1.67A1.67,1.67,0,0,1,270.28,266.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.27,147.16a3.68,3.68,0,1,1-3.68-3.67A3.68,3.68,0,0,1,139.27,147.16Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.31,147.16a1.72,1.72,0,1,1-1.72-1.72A1.72,1.72,0,0,1,137.31,147.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.58,
    y: 388.32,
    width: 31.73,
    height: 7.5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.71,
    y: 395.82,
    width: 45.48,
    height: 14.71,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.9,209h-34V171.44h22.18a7.76,7.76,0,0,1,7.68,6.73Z",
    style: {
      fill: "#2C3891"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.66,197.6H128.74a1.7,1.7,0,0,1-.51-.07,1.81,1.81,0,0,1-1.28-1.72V175.73h11.32a5.44,5.44,0,0,1,1.14.11,6.24,6.24,0,0,1,2.37.94,6.31,6.31,0,0,1,1.32,1.2,6.39,6.39,0,0,1,1.43,3.23l1.9,14.36A1.79,1.79,0,0,1,144.66,197.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143,187.12a1.8,1.8,0,0,1-.53,1.27l-9.21,9.21h-4.47a1.7,1.7,0,0,1-.51-.07l11.67-11.67a1.79,1.79,0,0,1,3,1.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.1,178,127,194.13v-2.52l14.83-14.83A6.31,6.31,0,0,1,143.1,178Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.41,175.84,130.23,185a1.34,1.34,0,0,1-1.89-1.89l7.4-7.39h2.53A5.44,5.44,0,0,1,139.41,175.84Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 208.14,
    y: 298.33,
    width: 95.24,
    height: 63.06,
    transform: "translate(102.54 -58.4) rotate(16.25)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,346.91l0-.15,17.69-60.7.16.05,91.58,26.7-17.74,60.85-.15-.05Zm18-60.45L201.42,346.7l91.12,26.56L310.11,313Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.14,332.89a10.81,10.81,0,1,1-7.35-13.41A10.81,10.81,0,0,1,266.14,332.89Z",
    style: {
      fill: "#2C3891"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.1 332.97 252.66 324.2 262.36 331.78 250.1 332.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.01,
    y: 355.31,
    width: 95.24,
    height: 4.93,
    transform: "translate(110.03 -55.01) rotate(16.25)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.85,
    y: 356.54,
    width: 80.16,
    height: 1.46,
    transform: "translate(109.82 -54.55) rotate(16.25)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.68,
    y: 343.56,
    width: 3.11,
    height: 3.11,
    transform: "translate(104.75 -43.37) rotate(16.25)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.43,
    y: 343.97,
    width: 0.59,
    height: 2,
    transform: "translate(104.69 -43.23) rotate(16.25)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.45,
    y: 344.27,
    width: 0.59,
    height: 2,
    transform: "translate(104.88 -43.52) rotate(16.26)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.57,
    y: 367.73,
    width: 3.11,
    height: 3.11,
    transform: "translate(114.83 -65.6) rotate(16.25)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.07,
    y: 368.69,
    width: 0.61,
    height: 0.76,
    transform: "translate(114.75 -65.4) rotate(16.25)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.08 370.17 286.33 369.44 286.54 368.72 287.56 368.51 287.08 370.17",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--u5Zjqx--inject-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.92,368.92l.17-.1a1,1,0,0,1-.4,1.37l-.1-.17a.82.82,0,0,0,.33-1.1Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5,369.84l-.1-.17a.39.39,0,0,0,.2-.25.37.37,0,0,0,0-.31l.17-.1A.6.6,0,0,1,287.5,369.84Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 289.14,
    y: 368.77,
    width: 3.11,
    height: 3.11,
    transform: "translate(115.26 -66.56) rotate(16.25)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.77,
    y: 369.17,
    width: 1.29,
    height: 1.29,
    transform: "translate(115.1 -66.5) rotate(16.25)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.33,
    y: 370.26,
    width: 1.29,
    height: 1.29,
    transform: "translate(115.42 -66.61) rotate(16.25)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.87,350.26a1.75,1.75,0,0,0-.05.75l-14.57-4.25.41-1.41,14.58,4.25A1.59,1.59,0,0,0,221.87,350.26Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.07,351.19a1.63,1.63,0,0,1-.36.66,1.68,1.68,0,0,1-2.89-.84,1.75,1.75,0,0,1,.05-.75,1.59,1.59,0,0,1,.37-.66,1.65,1.65,0,0,1,1.69-.48,1.67,1.67,0,0,1,1.18,1.32A1.74,1.74,0,0,1,225.07,351.19Z",
    style: {
      fill: "#a6a6a6"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopmentCuate);
export default __webpack_public_path__ + "static/media/development-cuate.dec0da2ae133ac6f01ea7df39e788a05.svg";
export { ForwardRef as ReactComponent };